import { Component } from "@angular/core";

@Component({
    selector: "app-home",
    standalone: true,
    imports: [],
    templateUrl: "./home.component.html",
    styleUrl: "./home.component.scss",
})
export class HomeComponent {
    title =
        "eDoc is an online document signing platform for transportation industry.  To access your agreement please contact your sales agent who will send you a direct link to the page where you can view and sign your agreement.  Agreements which have already been signed can be accessed from the same link and are stored on eDoc system perpetually.";
}

